import request from "../../config/axios";
// /wp-json/wc/v3/products/attributes/2/terms

const getAttributes = () => {
    return request.get(`/wp-json/wc/v3/products/attributes`)
}

const getAttributeById = (id) => {
    return request.get(`/wp-json/wc/v3/products/attributes/${id}/terms`)
}

const getAttributeFilter = async () => {
    const res = await getAttributes();

    const filtered = res.filter(
        (item) => item.name === "Gemstone" || item.name === "Type"
    );

    const results = await Promise.all(filtered.map((item) =>
        getAttributeById(item.id).then((terms) => ({
            name: item.name,
            terms,
        }))
    ));

    // Trả về object với key là tên attribute
    const final = results.reduce((acc, item) => {
        acc[item.name] = item.terms;
        return acc;
    }, {});

    return final;
};

export { getAttributeFilter }